import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ApiserviceService } from "../../../../apiservice.service";
import { CommonfunctionService } from "../../../../services/commonfunction.service";
import { Subscription } from "rxjs";

@Component({
  selector: "attribute-dialog",
  templateUrl: "./attribute-dialog.html",
  styleUrls: ["./copy-attribute-dialog.component.scss"],
})
export class AttributeDialog implements OnDestroy {
  selected_attr_list: any;
  selected_entity_type: any;
  selected_property_types: any = [];
  is_property_dependent: boolean;
  copySelected: string = 'entity'; // Default value
  private subs = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<AttributeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api: ApiserviceService,
    private readonly fnc: CommonfunctionService
  ) {
    this.selected_attr_list = this.data.parent.selected_attr_list;
  }

  getEntity(e) {
    if (e.value == "property_unit") {
      this.is_property_dependent = true;
    } else {
      this.is_property_dependent = false;
    }
  }
  pasteAttributes() {
    let data = {
      added_by: this.api.user_id,
      attribute_ids: this.selected_attr_list,
    };
    if (this.selected_property_types.length == 0) {
      data["property_type_ids"] = null;
    } else {
      data["property_type_ids"] = this.selected_property_types;
    }

    const pasteAttriSub = this.api
      .postEmsData(this.selected_entity_type + "/attributes/copy", data)
      .subscribe({
        next: (res) => {
          this.data.parent.notify.notify(
            "Attribute copied successfully!",
            "success"
          );
          this.close();
        },
        error: (err) => {
          this.data.parent.notify.notify(
            this.fnc.getErrorMessage(err),
            "error"
          );
        },
      });
      this.subs.add(pasteAttriSub);
  }
  close() {
    this.dialogRef.close();
  }
  getBooleanValue(): boolean {
    return this.copySelected === 'cities';
  }
  copyType: string = 'entity'; // default to entity
  selectedOption: string;
  options: string[] = ['Entity 1', 'Entity 2', 'Entity 3', 'City 1', 'City 2']; // dropdown options

  onPaste(): void {
    if (this.selectedOption) {
      // logic to handle paste action
      console.log('Pasting:', this.selectedOption);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
